<template>
  <div class="home container">
    <b-navbar class="qoo-nav" toggleable="lg" type="light" variant="transparent">
      <b-navbar-brand href="#"><img class="login-logo" src="@/assets/img/logo-small.png"/>
        <span style="padding-left: 20px; color: #10443B;">QooSquare</span>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class=" qoo-nav-center ml-auto">
          <b-nav-item href="#">Features</b-nav-item>
          <b-nav-item href="#">About</b-nav-item>
          <b-nav-item href="#">Blog</b-nav-item>
          <b-nav-item href="#">Contact Us</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="!auth.authLoading && auth.userInfo.id === ''" class="qoo-nav-items d-inline" :href="loginUrl">Login</b-nav-item>
          <b-nav-item v-if="!auth.authLoading && auth.userInfo.id === ''" class="d-inline" :href="signUpUrl"><button class="nav-btn">Sign Up</button></b-nav-item>
          <b-spinner v-if="auth.authLoading" />
          <b-nav-item-dropdown v-if="!auth.authLoading && auth.userInfo.id !== ''" right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <em>{{ auth.userInfo.firstName }} {{ auth.userInfo.lastName }}</em>
            </template>
            <b-dropdown-item href="#">Profile</b-dropdown-item>
            <b-dropdown-item @click="logout()" href="#">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>

          <!--                    <b-nav-item-dropdown right>-->
          <!--                        &lt;!&ndash; Using 'button-content' slot &ndash;&gt;-->
          <!--                        <template #button-content>-->
          <!--                            <em>User</em>-->
          <!--                        </template>-->
          <!--                        <b-dropdown-item href="#">Profile</b-dropdown-item>-->
          <!--                        <b-dropdown-item href="#">Sign Out</b-dropdown-item>-->
          <!--                    </b-nav-item-dropdown>-->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <!--        Section one-->
    <b-row class="section-one">
      <b-col col="12" md="5">
        <p class="heading-one">QooSquare Peaple</p><br>
        <p class="sub-heading-one">Automating and streamlining business processes and interactions </p>
        <br><br>
        <b-form-group>
          <b-form-group>
            <b-input-group>
<!--              <input class="qoo-input col-8" placeholder="Your email" required type="email"/>-->
              <a class="nav-btn col-4" :href="navigate('people.qoosquare.com')">Get Started</a>
<!--              <button class="nav-btn col-4">Get Started</button>-->
            </b-input-group>
          </b-form-group>
        </b-form-group>
      </b-col>
      <b-col  md="1">
      </b-col>
      <b-col cols="6" md="2">
        <p ><a :href="navigate('people.qoosquare.com')"><img class="service-icon" src="@/assets/img/cash.png"></a></p>
        <p class="p1">People</p>
        <p class="p2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
        <p class="p2 more-link">Learn more</p>
        <br><br><br>
        <p><img  class="service-icon" src="@/assets/img/Group182.png"></p>
        <p class="p1">Inventory</p>
        <p class="p2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
        <p class="p2 more-link">Learn more</p>
      </b-col>
      <b-col cols="6" class="service-col" md="2">
        <p><img  class="service-icon" src="@/assets/img/Group181.png"></p>
        <p class="p1">Sales</p>
        <p class="p2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
        <p class="p2 more-link">Learn more</p>
        <br><br><br>
        <p><img  class="service-icon" src="@/assets/img/Group183.png"></p>
        <p class="p1">Account</p>
        <p class="p2">Lorem Ipsum is simply dummy text of theprinting and typesetting industry.</p>
        <p class="p2 more-link">Learn more</p>
      </b-col>
      <b-col cols="6" class="service-col d-none d-md-block" md="2">
        <p><img  class="service-icon" src="@/assets/img/icons/Group 22212.png"></p>
        <p class="p1">CRM</p>
        <p class="p2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
        <p class="p2 more-link">Learn more</p>
        <br><br><br>
        <p><img  class="service-icon" src="@/assets/img/icons/box (1).png"></p>
        <p class="p1">Products</p>
        <p class="p2">Lorem Ipsum is simply dummy text of theprinting and typesetting industry.</p>
        <p class="p2 more-link">Learn more</p>
      </b-col>
    </b-row>
    <!--        /-->
    <!--        Section Three-->
    <b-row class="section-two">
      <img style="width: 100%" src="@/assets/img/footer box@3x.png">
    </b-row>
    <!--        /-->
    <!--        Section Two-->
    <b-row style="padding-bottom: 50px;" class="section-two">
      <b-col cols="6" md="2">
        <img class="d-md-block login-logo-footer" src="@/assets/img/logo-small.png">
        <br>
        <p style="color: #10443B;"><strong>QooSquare</strong><br>
          <span style="font-size: 11px;">(c) 2020</span>
        </p>
      </b-col>
      <b-col  cols="6" md="3" style="color: #4A4A4A;">
        <p><b>QooSquare</b></p><br>
        <p style="font-size: 11px;">Product Features</p>
        <p style="font-size: 11px;">Simply Everything</p>
        <p style="font-size: 11px;">Why Choose QooSquare</p>
      </b-col>
      <b-col cols="6" class="service-col d-block" md="2">
        <p><b>Company</b></p><br>
        <p style="font-size: 11px;">Support</p>
        <p style="font-size: 11px;">Login</p>
        <p style="font-size: 11px;">Sign up</p>
      </b-col>
      <b-col cols="6" md="3">
        <p><b>Further information</b></p><br>
        <p style="font-size: 11px;">Contact sales team</p>
        <p style="font-size: 11px;">Email us</p>
      </b-col>
      <b-col cols="6" class="service-col" md="2">
        <p><b>Follow us</b></p><br>
        <b-row>
          <b-col cols="2"><img style="width: 20px;"  src="@/assets/img/icons/Icon awesome-facebook.png" /></b-col>
          <b-col cols="2"><img style="width: 20px;"  src="@/assets/img/icons/Group 22171.png" /></b-col>
          <b-col cols="2"><img style="width: 20px;"  src="@/assets/img/icons/Group 22214.png" /></b-col>
          <!--                    <b-col md="2"><img style="width: 20px;"  src="@/assets/img/icons/Group 22214.png" /></b-col>-->
          <!--                    <b-col md="2"><img style="width: 20px;"  src="@/assets/img/icons/Group 22214.png" /></b-col>-->
          <!--                    <b-col md="2"><img style="width: 20px;"  src="@/assets/img/icons/Group 22214.png" /></b-col>-->
        </b-row>
      </b-col>
    </b-row>
    <!--        /-->
  </div>
</template>

<script>
// import ImageUploadCard from "../../components/card/ImageUploadCard";
import {stage} from '@/app.config.json'
import {mapState} from 'vuex'
export default {
  name: "Logon.vue",
  components:{
    // ImageUploadCard
    // BaseButton
  },
  methods:{
    logout(){
      let iframe = document.getElementById('f');
      let win;
      try {
        win = iframe.contentWindow;
      } catch(e) {
        win = iframe.contentWindow;
      }
      win.postMessage(JSON.stringify({key: 'token', method: "remove", data: {}}), "*");
      window.location = '/'
    },
    navigate(_url){
      if (this.auth.token == null)
        return this.loginUrl
      else {
        if (stage === 'dev')
          return 'dev-'+_url
        else
          return _url
      }
    },
  },
  computed:{
    ...mapState([
      'auth'
    ]),
    loginUrl(){
      if (stage === 'dev')
        return 'https://dev-profile.qoosquare.com'
      else
        return 'https://profile.qoosquare.com'
    },
    signUpUrl(){
      if (stage === 'dev')
        return 'https://dev-profile.qoosquare.com/register'
      else
        return 'https://profile.qoosquare.com/register'
    },
  }
}
</script>

<style scoped>

</style>